module.exports = __webpack_public_path__ + "assets/img/2814.34d64ef1.svg";